/**
 * Utility functions for handling images
 */
import placeholderImage from '@/assets/placeholder-property.jpg';

export interface PropertyImage {
  url?: string;
  primary?: boolean;
  id?: string;
  name?: string;
  file?: File;
  preview?: string;
}

/**
 * Gets the primary image from an array of images
 * Falls back to the first image if no primary is set
 */
export const getPrimaryImage = (images: PropertyImage[] = []): PropertyImage | null => {
  if (!images || images.length === 0) {
    return null;
  }

  // First, try to find an image marked as primary
  const primaryImage = images.find(img => img.primary === true);
  
  // If found, return it
  if (primaryImage) {
    return primaryImage;
  }

  // Otherwise, return the first image as fallback
  return images[0];
};

/**
 * Gets the primary image URL from an array of images
 * Falls back to the first image URL if no primary is set
 */
export const getPrimaryImageUrl = (images: PropertyImage[] = [], fallbackUrl?: string): string => {
  const primaryImage = getPrimaryImage(images);
  
  // Try both url and preview properties
  if (primaryImage?.url) {
    return primaryImage.url;
  }
  
  if (primaryImage?.preview) {
    return primaryImage.preview;
  }

  return fallbackUrl || placeholderImage;
};
